import React from "react";
import "./PaceAlert.css";
import { usePhotoCountsSnapshot } from "../PhotoCounts";
import {
  computePace,
  paceAlertText,
  paceFastText,
  RED_PROTOCOL_STEPS,
} from "../../../../../shared/minimePace";

/**
 * PaceAlert — the pace attention strip under the top pills (tier 2, client
 * spec 2026-08-01): silent while green/warmup; orange = "pay attention" line;
 * red = "take initiative" + the client's 4-step escalation protocol. The
 * too-fast note is its OWN line and shows alongside any state (review
 * finding: it must not be swallowed by orange). Display-only, no
 * interaction — the photographer acts in the real world, not in the app.
 */
const PaceAlert = ({ eventName }) => {
  const st = usePhotoCountsSnapshot(eventName);
  if (!st.server) return null;
  const pace = computePace(st.server);
  const stateText = paceAlertText(pace);
  const fastText = paceFastText(pace);
  if (!stateText && !fastText) return null;

  return (
    <>
      {stateText && (
        <div className={`minime-pace-alert rtl ${pace.state === "red" ? "red" : "orange"}`}>
          <div className="minime-pace-alert-line">{stateText}</div>
          {pace.state === "red" && (
            <ol className="minime-pace-alert-protocol">
              {RED_PROTOCOL_STEPS.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          )}
        </div>
      )}
      {fastText && (
        <div className="minime-pace-alert rtl fast">
          <div className="minime-pace-alert-line">{fastText}</div>
        </div>
      )}
    </>
  );
};

export default PaceAlert;
